import React from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';


// TCC Redux
import { FullUI } from '../../redux/UI/ui.selectors'
import { closeToast } from '../../redux/UI/ui.actions'
// Components
import { ResetForm } from './ResetForm'
import { Toast } from '../Toast/Toast'
// Styles
import { SmartContainer, Stack, Surface } from '../../styles/Containers'
import { StyledAuthSurface } from './RecoverPage';

import logoLeft from '../../assets/logo-left-black-green.png';




export const ResetPage = () => {
    // Read State
    const dispatch = useDispatch()
    const ui = FullUI();

    const { token } = useParams();

    return (
        <Stack flex align="center" justify="center" padding={10} direction="column">
            <SmartContainer flex align="center" justify="center">
                <img src={logoLeft} alt="Capture Collab Logo" style={{ maxWidth: '200px', width: '76%', height: 'auto', marginBottom: '1em' }} />
            </SmartContainer>
            <StyledAuthSurface maxWidth="400px" textAlign="center">
                <ResetForm token={token} />
            </StyledAuthSurface>
            {ui.toast?.open && (<Toast onClose={() => dispatch(closeToast())} open={ui.toast?.open} severity={ui.toast?.severity} message={ui.toast?.message} />)}
        </Stack>
    )
}